var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from "axios";
import { ServiceDataBase } from "./ServiceData";
import ServiceErrors from "./ServiceErrors";
import ServiceInfo from "./ServiceInfo";
import { getModule } from '@/modules/store';
import ConfigStore from "@/modules/config/store/ConfigStore";
import { EVENTS } from '@/modules/eventbus';
import { getAppInstance } from '../../app';
import EventBusModule from '../../eventbus';
var SERVER_URL = process.env.VUE_APP_API_BASE_URL;
export var ServiceEndPoints = {
    ACADEMIC_SERVICES: SERVER_URL + '/Services/AcademicServiceRest.svc/',
    ACADEMIES_DATA_SERVICES: SERVER_URL + '/DataServices/Services/Academies/AcademiesDataServiceRest.svc/',
    ACADEMIC_USER_SERVICES: SERVER_URL + '/DataServices/Services/AcademicUsers/AcademicUsersDataServiceRest.svc/',
    EDUCATION_PROGRAMS_DATA_SERVICES: SERVER_URL + '/DataServices/Services/EducationPrograms/EducationProgramsDataServiceRest.svc/',
    MIDDLE_EDUCATION_PROGRAMS_DATA_SERVICES: SERVER_URL + '/Services/AcademicServiceRest.svc/',
    UPLOAD_SERVICES: SERVER_URL + '/Services/UploadFile.aspx',
    DIPLOMA_TEMPLATES_SERVICES: SERVER_URL + '/DataServices/Services/DiplomaTemplates/DiplomaTemplatesDataServiceRest.svc/',
    DASHBOARD_SERVICES: SERVER_URL + '/DataServices/Services/Dashboard/DashboardServiceRest.svc/',
};
var ServiceBase = (function () {
    function ServiceBase() {
    }
    Object.defineProperty(ServiceBase.prototype, "userToken", {
        get: function () {
            var configStore = getModule(ConfigStore);
            return configStore.userToken;
        },
        enumerable: false,
        configurable: true
    });
    ServiceBase.prototype.getServiceInfo = function () {
        var configStore = getModule(ConfigStore);
        var serviceInfo = new ServiceInfo();
        serviceInfo.token = configStore.userToken;
        serviceInfo.language = configStore.userLanguage;
        return serviceInfo;
    };
    ServiceBase.prototype.postData = function (address, data, config, dstServiceDataInstance, postProcessor) {
        var _this = this;
        if (data && !(data instanceof FormData))
            data = __assign({ serviceInfo: __assign({}, this.getServiceInfo().getData()) }, (data instanceof ServiceDataBase ? data.getData() : data));
        return new Promise(function (resolve, reject) {
            axios.post(address, data, config)
                .then(function (response) {
                var responseData = response.data;
                console.log('responseData', responseData, dstServiceDataInstance);
                var serviceErrors = _this.catchErrorsInResponseData(responseData);
                var isSuccess = false;
                if (responseData) {
                    if (responseData && typeof responseData === 'object' && 'IsSuccess' in responseData && responseData.IsSuccess === true)
                        isSuccess = true;
                }
                console.log('serviceErrors', serviceErrors, serviceErrors.hasErrors(), isSuccess);
                if (serviceErrors.hasErrors() && !isSuccess) {
                    _this.checkSessionExpired(serviceErrors);
                    reject(serviceErrors);
                }
                else {
                    if (dstServiceDataInstance) {
                        console.log('setting data', responseData, dstServiceDataInstance);
                        dstServiceDataInstance.setData(responseData);
                        console.log('data set', responseData, dstServiceDataInstance);
                        if (postProcessor)
                            dstServiceDataInstance = postProcessor(dstServiceDataInstance);
                        resolve(dstServiceDataInstance);
                    }
                    else {
                        var res = responseData;
                        if (postProcessor)
                            res = postProcessor(res);
                        resolve(res);
                    }
                }
            })
                .catch(function (error) {
                var serviceErrors = _this.catchErrorsInResponseData(error.response ? error.response.data : error);
                if (!serviceErrors.raw)
                    serviceErrors.raw = error;
                console.log('error', JSON.stringify(error), dstServiceDataInstance);
                _this.checkSessionExpired(serviceErrors);
                reject(serviceErrors);
            });
        });
    };
    ServiceBase.prototype.catchErrorsInResponseData = function (responseData) {
        var serviceErrors = new ServiceErrors();
        if (responseData) {
            if (responseData.ErrorList && responseData.ErrorList.length > 0) {
                serviceErrors.raw = responseData;
                serviceErrors.errors = responseData.ErrorList;
            }
            if (Object.prototype.hasOwnProperty.call(responseData, 'Details') && Object.prototype.hasOwnProperty.call(responseData, 'Message')) {
                serviceErrors.raw = responseData;
                serviceErrors.errors = [responseData.Message];
            }
            if (Object.prototype.hasOwnProperty.call(responseData, 'ErrorList') && Array.isArray(responseData.ErrorList) && responseData.ErrorList.length > 0) {
                serviceErrors.raw = responseData;
                serviceErrors.errors = __spreadArray([], responseData.ErrorList, true);
            }
            if (responseData.ErrorCode && responseData.ErrorCode === 1) {
                serviceErrors.raw = responseData;
                serviceErrors.errors = [responseData.ErrorCode];
                serviceErrors.errorCodes = [responseData.ErrorCode];
            }
        }
        return serviceErrors;
    };
    ServiceBase.prototype.checkSessionExpired = function (serviceErrors) {
        if (serviceErrors.isSessionExpired()) {
            var eventBusModule = getAppInstance().getModuleByType(EventBusModule);
            eventBusModule.bus.emit(EVENTS.SESSION_EXPIRED);
        }
    };
    return ServiceBase;
}());
export { ServiceBase };



//////////////////
// WEBPACK FOOTER
// ./src/modules/services/models/ServiceBase.ts
// module id = null
// module chunks = 